import { createReducer } from '@topconagriculture/frontend-utils';
import * as dotProp from 'dot-prop-immutable';
import { logout, setAuthProps } from './auth.actions';
export const initialState = {
    authProps: null,
};
const authReducer = createReducer(initialState, {
    [setAuthProps.type]: (state, action) => {
        return dotProp.set(state, 'authProps', action.payload.result);
    },
    [logout.started.type]: (state) => {
        return dotProp.set(state, 'authProps', null);
    },
});
export default { auth: authReducer };
//# sourceMappingURL=auth.reducer.js.map